/**
 * Onboarding Action Button
 * 
 * Dynamic bottom button that changes text based on onboarding state
 * Opens chat with contextual dialogue when clicked
 */

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  isOnboardingActive,
  getCurrentPhase,
  getButtonText,
  getInstructionText,
  ONBOARDING_PHASES
} from '../../utils/onboardingStateMachine';

const ButtonContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 90%;
  max-width: 350px;
  
  @media (max-width: 768px) {
    bottom: 15px;
    width: 85%;
  }
`;

const ActionButton = styled.button`
  width: 100%;
  padding: 16px 20px;
  background: linear-gradient(135deg, #FF2300 0%, #FF4500 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(255, 35, 0, 0.4);
  transition: all 0.2s ease;
  text-align: center;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 35, 0, 0.5);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    padding: 14px 18px;
    font-size: 13px;
  }
`;

const InstructionText = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 8px;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

export const OnboardingActionButton = ({ onClick, showInstructions = false }) => {
  const [buttonText, setButtonText] = useState('');
  const [instructionText, setInstructionText] = useState('');
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    // Check if onboarding is active
    const active = isOnboardingActive();
    setIsActive(active);
    
    if (active) {
      // Get button text for current phase
      const text = getButtonText();
      setButtonText(text);
      
      // Get instruction text if applicable
      if (showInstructions) {
        const instructions = getInstructionText();
        setInstructionText(instructions);
      }
    }
  }, [showInstructions]);

  // Don't render if onboarding is not active
  if (!isActive || !buttonText) {
    return null;
  }

  return (
    <ButtonContainer>
      <ActionButton onClick={onClick}>
        {buttonText}
      </ActionButton>
      {instructionText && (
        <InstructionText>{instructionText}</InstructionText>
      )}
    </ButtonContainer>
  );
};

export default OnboardingActionButton;


